module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAZlBMVEUAAABmZv9VVf9Jbf9Vav9aaf9VYf9RaP9SZv9TZv9VZP9VZP9TY/9TZf9VZf9UZf9UY/9UZP9UZP9UZP9UZP9VZP9UY/9VZP9UZP9UZP9UZf9UZP9UZP9UZP9UZP9UZP9UZP9UZP87yoiDAAAAIXRSTlMABQYHDBEVFhk3QkVQaG98lZers7e4w83Oz9Xq8PP5+vsc7/GkAAAAfElEQVQ4y+3T2Q6CQAyF4eLGKosCojij5/1fkmRI1NFQSryk/1Un/a6aDJH2W9wYuEx73MzYxOLd9cDjDlU4TvvsgjOPnwhe8w4PHgMfjx5bOT4hk+MUXvZWBNOY8t7nKBnsF9W4izFFX1vM9A8W30qx4lXjBd+KlljNNQBd/SSlFHDcGQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/course/zhisdian@2x.png
// module id = gGxu
// module chunks = 0